import Filter from '@app/components/atoms/FilterHome/FilterHome'
import GridCard from '@app/components/atoms/GridCard/GridCard'
import PaginationNotTable from '@app/components/atoms/PaginationNotTable/PaginationNotTable'
import { createFilters } from '@app/libs/tableUtil'
import useRemember from '@app/libs/useRemember'
import { DataFilter, DataPaging } from '@data/Partner/RequestCampaignData'
import Grid from '@mui/material/Grid'
import { useSnackbar } from 'notistack'
import { useEffect, useState } from 'react'
import { Translation, useTranslation } from 'react-i18next'
import { useMutation, useQueryClient } from 'react-query'

export default function RequestCampaignIndex({ vouchers, categories, tags }) {
  const [dataCart, setDataCart] = useRemember('cartVoucher', [])
  const [dataItems, setDataItems] = useState([])
  const queryClient = useQueryClient()
  const mutation = useMutation(() => {}, {
    onSuccess: () => {
      queryClient.invalidateQueries('listCartVoucher')
    },
  })

  const { t } = useTranslation()

  const handleDelete = (dataToSave, item) => {
    const IndexMerchant = dataToSave.findIndex((r) => r?.type === item?.type)
    if (-1 !== IndexMerchant) {
      const index = dataToSave[IndexMerchant]['data'].findIndex((r) => r?.id === item?.id)
      if (-1 !== index) {
        dataToSave[IndexMerchant]['data'].splice(index, 1)
        if (0 === dataToSave[IndexMerchant]['data'].length) {
          dataToSave.splice(IndexMerchant, 1)
          setDataCart(dataToSave)
        } else {
          setDataCart(dataToSave)
        }
      } else {
        dataToSave[IndexMerchant]['data'].push(item)
        setDataCart(dataToSave)
      }
    }
  }

  const handleAdd = (item) => {
    mutation.mutate()
    const dataToSave = [...dataCart]
    if (0 === dataCart.length || !dataCart.some((r) => r?.type === item?.type)) {
      dataToSave.push({
        type: item?.type,
        data: [item],
      })
      setDataCart(dataToSave)
    } else {
      handleDelete(dataToSave, item)
    }
  }
  const { enqueueSnackbar } = useSnackbar()

  const handleCheck = (item) => {
    if (0 === dataCart.length || !dataCart.some((r) => r?.data.some((d) => d.id === item.id))) {
      enqueueSnackbar(t('ALERT.ADD_CART'), {
        variant: 'success',
      })
    } else {
      enqueueSnackbar(t('ALERT.REMOVE_CART'), {
        variant: 'warning',
      })
    }
  }

  const [DataFilters, setDataFilters] = useState(createFilters(DataFilter))

  useEffect(() => {
    if (dataCart && 0 < dataCart.length) {
      let joinArr = []
      dataCart.map((r) => (r.data || []).map((i) => (joinArr = [...joinArr, i])))
      setDataItems(joinArr)
    } else {
      setDataItems([])
    }
  }, [dataCart])

  useEffect(() => {
    DataFilter[1]['options'] = categories
    DataFilter[3]['options'] = [
      { id: 'premium', name: <Translation>{(t) => t('VOUCHERS.PREMIUM')}</Translation> },
      { id: 'standard', name: <Translation>{(t) => t('VOUCHERS.STANDARD')}</Translation> },
    ]
    DataFilter[2]['options'] = tags
    setDataFilters(createFilters(DataFilter))
  }, [tags])

  const onFilter = (values) => {
    onPaging(1)
    DataFilter[2]['value'] = []
  }

  const onPaging = (value) => {
    DataPaging[0]['page'] = value
  }

  useEffect(() => {
    onPaging(vouchers.current_page)
    const values = Object.fromEntries(new URLSearchParams(location.search))

    if (values && 0 < Object.keys(values).length) {
      Object.keys(values).forEach((value) => {
        const indexCheck = DataFilter.findIndex((r) => {
          const reg = new RegExp(`^${r.id}`)
          return reg.test(value)
        })
        if (-1 !== indexCheck && 'multiSelect' === DataFilter[indexCheck]['type']) {
          const params = DataFilter[indexCheck]['value'] || []
          if (!params.some((param) => values[value] === param)) params.push(values[value])
          DataFilter[indexCheck]['value'] = params
        }
      })
      setDataFilters(createFilters(DataFilter))
    }
  }, [])

  const pageNumber = Math.ceil(vouchers.total / 20)

  return (
    <Grid container justifyContent="center">
      <Grid item xs={12}>
        <Filter expandable={true} filters={DataFilters} nameRoute="partner.home" onFilter={onFilter} />
      </Grid>
      <GridCard data={vouchers.data} dataItems={dataItems} handleChange={handleAdd} handleCheck={handleCheck} />
      <PaginationNotTable
        filter={DataFilter}
        nameRoute="partner.home"
        pageNumber={pageNumber}
        paging={DataPaging}
        setPaging={onPaging}
      />
    </Grid>
  )
}
